<template>
    <div>
        <div class="content-header related-doc-header mt-4">
            <div class="content-header-left">
                <!-- <h2>Company Documents</h2> -->
            </div>
            <div class="content-header-right">
                <vs-inv-dropdown v-if="!fromDetailsPage">
                    <div class="filters-content">
                        <div class="filters-form-fileds noscroll">
                            <div class="form-container overflow_visible">
                                <div class="vx-row">
                                    <div class="vx-col md:w-1/2 w-full con-select">
                                        <label class="typo__label">Tags</label>
                                        <multiselect v-model="selectedTagsForFilter" :options="tagsList" :multiple="true"
                                            :hideSelected="true" :close-on-select="false" :clear-on-select="false"
                                            :select-label="''" :preserve-search="true" placeholder="Select Tags"
                                            label="tag" track-by="tag" :preselect-first="false">
                                            <template slot="selection" slot-scope="{ values, isOpen }">
                                                <span class="multiselect__selectcustom"
                                                    v-if="values.length && !isOpen">{{ values.length }}
                                                    option(s) selected</span>
                                                <span class="multiselect__selectcustom"
                                                    v-if="values.length && isOpen"></span>
                                            </template>
                                        </multiselect>
                                    </div>
                                    <div class="vx-col md:w-1/2 w-full con-select">
                                        <label class="typo__label">Created Date</label>
                                        <date-range-picker :maxDate="new Date()" :autoApply="autoApply" :ranges="false" 
                                            v-model="selectedDateRange"></date-range-picker> 
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="filters-status">
                            <div class="left-buttons">
                            </div>
                            <div class="right-buttons">
                                <button color="success" class="btn light_blue_btn" type="filled"
                                    v-on:click="set_filter()">Apply</button>
                                <button color="dark" class="btn gray_btn mr-3" type="filled"
                                    v-on:click="clear_filter($event)">Clear </button>
                            </div>
                        </div>
                    </div>
                </vs-inv-dropdown>
                <div class="pd_upload_actions pd_upload_actions_v2 mb-0" v-if="!fromDetailsPage"
                    @click="formerrors.msg = ''; document = []; uploadFinalMainDocuments = []; openAddDocPopup()">
                    <span class="upload-btn">
                        <img src="@/assets/images/main/upload.svg" />Upload
                    </span>
                </div>
                <button v-if="!fromDetailsPage" color="primary" type="border" class="btn light_blue_btn mr-2"
                    @click="$modal.show('manageTagsModal')">Manage Tags<span></span></button>
                <!-- <button v-if="!fromDetailsPage" color="primary" type="border" class="btn light_blue_btn mr-2">Audit Blinder<span></span></button> -->
                <button v-if="fromDetailsPage" color="primary" type="border" class="btn light_blue_btn mr-2" @click="openAttachFromLibrary">Attach from Company Library <span></span></button>
            </div>
        </div>

        <!-- <div class="tab-inner-content">
            <div class="tabs-content-panel pad20">
                <div class="card-panels pt-0">

                    <vs-row vs-justify="center">
                        <vs-col class="p-0" type="flex" vs-justify="center" vs-align="center" vs-w="12">

                            <vs-card class="no-card">
                                <div v-if="documentsList.length > 0" class="forms_accordian">

                                    <vs-collapse accordion>
                                        <template v-for="(forms, index) in documentsList">
                                            v-if="(currentRole ==12 && forms.selectedForSigning ) || currentRole !=12 "
                                            <vs-collapse-item
                                                :class="{ 'closeDropdown': [48, 50].indexOf(getUserRoleId) > -1, 'no-list': (checkProperty(forms, 'reverse_document_versions') && forms['reverse_document_versions'].length == 0) }"
                                                :not-arrow="!(checkProperty(forms, 'reverse_document_versions') && forms['reverse_document_versions'].length >= 0)"
                                                :key="index">
                                                <div slot="header" class="ss">

                                                    <vs-list-item :title="forms.name" :subtitle="getformated(forms)">

                                                        <template slot="avatar">
                                                            <img v-if="checkFileFormat(forms['mimetype']) == 'pdf'"
                                                                src="@/assets/images/main/pdf.svg" />
                                                            <img v-else-if="checkFileFormat(forms['mimetype']) == 'video_mime_types'"
                                                                src="@/assets/images/main/film.png" />
                                                            <img v-else-if="checkFileFormat(forms['mimetype']) == 'msDoc'"
                                                                src="@/assets/images/main/doc.svg" />
                                                            <img v-else-if="checkFileFormat(forms['mimetype']) == 'zip'"
                                                                src="@/assets/images/main/zip-file-format.png" />
                                                            <img v-else-if="checkFileFormat(forms['mimetype']) == 'msPpt'"
                                                                src="@/assets/images/main/ppt.svg" />
                                                            <img v-else-if="checkFileFormat(forms['mimetype']) == 'msXl'"
                                                                src="@/assets/images/main/xls.svg" />
                                                            <img v-else-if="checkFileFormat(forms['mimetype']) == 'image'"
                                                                src="@/assets/images/main/image.svg" />
                                                            <img v-else src="@/assets/images/main/icon-img.svg" />
                                                        </template>
<div class="vertical-menu">
    <span class="menu-icon">
        <i class="material-icons">more_vert</i>
    </span>

    <ul>

        <li v-if="[50].indexOf(currentRole) >-1 " @click="selDoc(forms.mainParentId)">Upload</li>

        <li @click="fetchSignedUrl(forms, false, true)">View
        </li>
        <li @click="downloads3file(forms)">Download</li>
        <li @click="openConformPopUp(forms)">Delete</li>
    </ul>
</div>
</vs-list-item>
</div>
</vs-collapse-item>
</template>
</vs-collapse>
</div>

<paginate v-if="documentsList.length>0" v-model="page" :page-count="totalpages" :page-range="3" :margin-pages="2"
    :click-handler="pageNate" prev-class="vs-pagination--buttons btn-prev-pagination vs-pagination--button-prev"
    next-class="vs-pagination--buttons btn-next-pagination vs-pagination--button-next" :prev-text="'<i></i>'"
    :next-text="'<i></i>'" :container-class="'pagination vs-pagination--nav'" :page-class="'page-item'"></paginate>


<NoDataFound ref="NoDataFoundRef" :loading="isListLoading" v-if="documentsList.length == 0" content=""
    heading="No Documents Found" type='documents' />

</vs-card>
</vs-col>
</vs-row>


</div>
</div>
</div> -->

        <NoDataFound ref="NoDataFoundRef" :loading="isListLoading" v-if="checkProperty(documentsList, 'length') == 0"
            content="" :heading="'No Documents Found'" type='petitioner' />
        <div class="accordian-table paf_table related_documents" v-if="checkProperty(documentsList, 'length') > 0">
            <vs-table :data="documentsList">
                <template slot="thead">
                    <vs-th><a>Title</a></vs-th>
                    <vs-th><a>Version</a></vs-th>
                    <vs-th><a>Tags</a></vs-th>
                    <vs-th v-if="!fromDetailsPage"><a>Linked Cases</a></vs-th>
                    <vs-th><a>Status</a></vs-th>
                    <vs-th><a>Actions</a></vs-th>
                </template>
                <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in documentsList">
                        <vs-td>
                            <span class="cursor">
                                {{ checkProperty(tr, 'name') | CapSubString }}
                            </span>
                        </vs-td>
                        <vs-td>
                            <span class="cursor">
                                {{ checkProperty(tr, 'version') ? `v${checkProperty(tr, 'version')}` : '--' }}
                            </span>
                        </vs-td>
                        <vs-td>
                            <div class="subtypes__list" v-if="checkProperty(tr, 'tags', 'length') > 0">
                                <ul>
                                    <template v-if="checkProperty(tr['tags'][0], 'tag')">
                                        <li>
                                            <span>{{ tr['tags'][0]['tag'] }}</span>
                                        </li>
                                    </template>
                                    <li v-if="checkProperty(tr, 'tags', 'length') > 1">
                                        <div class="menu_dropdown flexible_actions right">
                                            <em class="more_count">
                                                +{{ tr.tags['length'] - 1 }}
                                            </em>
                                            <div class="menu_list_wrap">
                                                <ul>
                                                    <VuePerfectScrollbar ref="mainSidebarPs"
                                                        class="scroll-area--main-sidebar" :settings="settings"
                                                        @ps-scroll-y="scrollHandle">
                                                        <template v-for="(tag, index) in tr.tags">
                                                            <li v-if="index > 0" :key="'tagName' + index">
                                                                {{ tag['tag'] }}
                                                            </li>
                                                        </template>
                                                    </VuePerfectScrollbar>
                                                </ul>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <span class="cursor" v-else>
                                --
                            </span>
                        </vs-td>
                        <vs-td v-if="!fromDetailsPage">
                            <div class="subtypes__list" v-if="checkProperty(tr, 'linkedI9', 'length') > 0">
                                <ul>
                                    <template v-if="checkProperty(tr['linkedI9'][0], 'customId')">
                                        <li>
                                            <span>{{ tr['linkedI9'][0]['customId'] }}</span>
                                        </li>
                                    </template>
                                    <li v-if="checkProperty(tr, 'linkedI9', 'length') > 1">
                                        <div class="menu_dropdown flexible_actions right">
                                            <em class="more_count">
                                                +{{ tr.linkedI9['length'] - 1 }}
                                            </em>
                                            <div class="menu_list_wrap">
                                                <ul>
                                                    <VuePerfectScrollbar ref="mainSidebarPs"
                                                        class="scroll-area--main-sidebar" :settings="settings"
                                                        @ps-scroll-y="scrollHandle">
                                                        <template v-for="(caseItem, index) in tr.linkedI9">
                                                            <li v-if="index > 0" :key="'tagName' + index">
                                                                {{ caseItem['customId'] }}
                                                            </li>
                                                        </template>
                                                    </VuePerfectScrollbar>
                                                </ul>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <span class="cursor" v-else>
                                --
                            </span>
                        </vs-td>
                        <vs-td>
                            <span
                                :class="{ 'status_active': checkProperty(tr, 'status') == true, 'status_rejected': checkProperty(tr, 'status') == false }"
                                class="cursor">
                                <template v-if="checkProperty(tr, 'status') == true">Active</template>
                                <template v-if="checkProperty(tr, 'status') == false">Archived</template>
                            </span>
                        </vs-td>
                        <vs-td>
                            <div class="menu_dropdown flexible_actions cursor-pointer" @click="$event.stopPropagation()">
                                <a class="a-icon" href.prevent>
                                    <more-vertical-icon size="1.5x" class="custom-class"></more-vertical-icon>
                                </a>
                                <div class="menu_list_wrap">
                                    <ul class="menu_list">
                                        <li class="menu_item"
                                            v-if="checkProperty(tr, 'path')"
                                            @click="fetchSignedUrl(tr, false, true)">
                                            View
                                        </li>
                                        <li class="menu_item"
                                            v-if="checkProperty(tr, 'path')"
                                            @click="downloads3file(tr)">
                                            Download
                                        </li>
                                        <li class="menu_item"
                                            v-if="checkProperty(tr, 'status') == true && !fromDetailsPage"
                                            @click="showPopupForReplace(tr)">
                                            Replace
                                        </li>
                                        <li class="menu_item"
                                            v-if="checkProperty(tr, 'status') == false && [50].indexOf(getUserRoleId) > -1 && checkProperty(tr, 'enableRestore') && !fromDetailsPage"
                                            @click="restoreDocument(tr)">
                                            Restore
                                        </li>
                                        <li class="menu_item"
                                            v-if="checkProperty(tr, 'status') == true && [50].indexOf(getUserRoleId) > -1 && !fromDetailsPage"
                                            @click="openConformPopUp(tr)">
                                            Delete
                                        </li>
                                        <li class="menu_item"
                                            v-if="checkProperty(tr, 'status') == true && !fromDetailsPage"
                                            @click="linkCaseOrTagToDocument(tr, 'case')">
                                            Link Case
                                        </li>
                                        <li class="menu_item"
                                            v-if="checkProperty(tr, 'status') == true && !fromDetailsPage"
                                            @click="linkCaseOrTagToDocument(tr, 'tag')">
                                            Add Tag
                                        </li>
                                        <li class="menu_item"
                                            v-if="fromDetailsPage"
                                            @click="openRemoveConfirmPopup(tr)">
                                            Remove
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </vs-td>
                        <template class="expand-user" slot="expand">
                            <div class="con-expand-users">
                                <div>
                                    <vs-table :data="tr.pinnedDocuments" :no-data-text="'No prior versions'">
                                        <template slot="thead">
                                            <vs-th>Title</vs-th>
                                            <vs-th>Version</vs-th>
                                            <vs-th>Actions</vs-th>
                                        </template>

                                        <template>
                                            <vs-tr :key="ind"
                                                v-for="(doc, ind) in checkProperty(tr, 'pinnedDocuments')">
                                                <vs-td :data="doc.name">
                                                    <span style="cursor:pointer">
                                                        {{ checkProperty(doc, 'name') | CapSubString }}
                                                    </span>
                                                </vs-td>

                                                <vs-td :data="doc.version">
                                                    <span style="cursor:pointer" @click="generatedPaf(tr)">
                                                        {{ 'v' + checkProperty(doc, 'version') }}
                                                    </span>
                                                </vs-td>

                                                <vs-td>
                                                    <ul class="td_actions">
                                                        <li class="tooltip_sec" v-if="checkProperty(doc, 'path')">
                                                            <a @click="downloads3file(doc)" class="download"
                                                                href.prevent>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="14"
                                                                    height="14" viewBox="0 0 24 24" fill="none"
                                                                    stroke="#506e98" stroke-width="2"
                                                                    stroke-linecap="round" stroke-linejoin="round">
                                                                    <path
                                                                        d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                                                    <polyline points="7 10 12 15 17 10" />
                                                                    <line x1="12" y1="15" x2="12" y2="3" />
                                                                </svg>
                                                            </a>
                                                            <div class="tooltip_cnt z-10">
                                                                <p>Download</p>
                                                            </div>
                                                        </li>
                                                        <li class="tooltip_sec" v-if="checkProperty(doc, 'path')">
                                                            <a @click="fetchSignedUrl(doc, false, true)"
                                                                class="download" href.prevent>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="14"
                                                                    height="14" viewBox="0 0 24 24" fill="none"
                                                                    stroke="#506e98" stroke-width="2"
                                                                    stroke-linecap="round" stroke-linejoin="round">
                                                                    <path
                                                                        d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z" />
                                                                    <circle cx="12" cy="12" r="3" />
                                                                </svg>
                                                            </a>
                                                            <div class="tooltip_cnt z-10">
                                                                <p>View</p>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </vs-td>
                                            </vs-tr>
                                        </template>
                                    </vs-table>
                                </div>
                            </div>
                        </template>
                    </vs-tr>
                </template>
            </vs-table>
            <!-- <span  
                  :class="
                  {'status_pending':checkProperty( tr,'statusId')==1,'status_active':checkProperty( tr,'statusId' ) ==2,'status_onHold':checkProperty( tr,'statusId' )==3,'status_rejected':checkProperty( tr,'statusId' )==4}">
                  {{checkProperty(tr, 'statusDetails', 'name')}}</span> -->
            <div class="table_footer">
                <div class="vx-col  con-select pages_select" v-if="checkProperty(documentsList, 'length') > 0">
                    <label class="typo__label">Per Page</label>
                    <multiselect @input="changeperPage()" v-model="perpage" :options="perPeges" :multiple="false"
                        :allow-empty="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true"
                        placeholder="Per Page" :preselect-first="true">
                    </multiselect>
                    <span class="totla_list_count" v-if="totalCount"> Total <em>{{ totalCount }}</em></span>
                </div>
                <paginate v-if="checkProperty(documentsList, 'length') > 0" v-model="page" :page-count="totalpages"
                    :page-range="3" :margin-pages="2" :click-handler="pageNate"
                    prev-class="vs-pagination--buttons btn-prev-pagination vs-pagination--button-prev"
                    next-class="vs-pagination--buttons btn-next-pagination vs-pagination--button-next"
                    :prev-text="'<i></i>'" :next-text="'<i></i>'" :container-class="'pagination vs-pagination--nav'"
                    :page-class="'page-item'"></paginate>
            </div>
        </div>

        <modal name="addDocumentPopup" classes="v-modal-sec" :min-width="200" :min-height="200" :scrollable="true"
            :reset="true" width="600px" height="auto">
            <div class="v-modal">
                <div class="popup-header fromDetailsPage">
                    <h2 class="popup-title">{{ replaceDocument ? 'Replace' : 'Upload' }}</h2>
                    <span @click="closeAddDocPopup()">
                        <em class="material-icons">close</em>
                    </span>
                </div>
                <fileUploadNote :fileNoteNew="true" />
                <div class="form-container pt-0">
                    <div class="vx-row">
                        <div class="vx-col md:w-1/2">
                            <div class="form_group city-form">
                                <div class="con-select con-select-mb20 select-large addselect">
                                    <label class="form_label">Tag(s)</label>
                                    <multiselect :name="'tags'" v-model="newDocument.tags" :show-labels="false"
                                        track-by="tag" label="tag" data-vv-as="Tag(s)" tag-placeholder="Add"
                                        :taggable="true" @tag="addTag" placeholder="Select Tag(s)" :options="tagsList"
                                        :searchable="true" :allow-empty="true" :multiple="true" :close-on-select="false"
                                        :hide-selected="true" :disabled="addingTag">
                                        <span slot="noResult">No Tags Found</span>
                                        <template slot="selection" slot-scope="{ values, isOpen }">
                                            <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{
                                                values.length }} Tag(s) Selected</span>
                                            <span class="multiselect__selectcustom"
                                                v-if="values.length && isOpen"></span>
                                        </template>
                                    </multiselect>
                                </div>
                                <span class="add-tag" @click="showAddTagPopup = true">Add new tag</span>
                            </div>
                        </div>
                        <div class="vx-col md:w-1/2">
                            <div class="form_group city-form">
                                <div class="con-select con-select-mb20 select-large addselect">
                                    <label class="form_label">Attach to Cases</label>
                                    <multiselect :name="'cases'" v-model="newDocument.cases" :show-labels="false"
                                        track-by="_id" label="name" data-vv-as="Attach to Cases"
                                        placeholder="Select Cases" :options="i9List"
                                        :custom-label="(item) => checkProperty(item, 'name') + ' (' + checkProperty(item, 'employeeName') + ')'"
                                        :searchable="true" :allow-empty="true" :multiple="true" :close-on-select="false"
                                        :hide-selected="true">
                                        <span slot="noResult">No Cases Found</span>
                                        <template slot="selection" slot-scope="{ values, isOpen }">
                                            <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{
                                                values.length }} Case(s) Selected</span>
                                            <span class="multiselect__selectcustom"
                                                v-if="values.length && isOpen"></span>
                                        </template>
                                    </multiselect>
                                </div>
                                <!-- <span class="add-tag" @click="openi9">Request I-9</span> -->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="add_doc_wrap">
                    <div class="vx-col w-full">

                        <div class="pad20 pt-0">

                            <div class="vx-row" @click="document = []">
                                <div class="vx-col w-full">
                                    <vx-input-group class="form-input-group select-upload-group">
                                        <div class="uploadsec_wrap">
                                            <div class="w-full">
                                                <file-upload v-model="document"
                                                    class="file-upload-input mb-0 fileupload_btn" :accept="allDocEntity"
                                                    name="lcaDocument" :multiple="false" :hideSelected="true"
                                                    data-vv-as="LCA document" :fieldName="'document'" :cid="'document'"
                                                    :emitCategory="'document'" @updateData="updateData">
                                                    <!-- v-validate="{ 'required': (lcastatusSelected && (lcastatusSelected.id == 2 || lcastatusSelected.id == 3)) }" -->
                                                    <!-- v-validate="{'required':(lcastatusSelected && lcastatusSelected.id == 2 || lcastatusSelected.id == 3)}"
                                -->
                                                    <figure class="loader loader2"><img
                                                            src="@/assets/images/main/loader.gif" />
                                                    </figure>
                                                    <img class="file-icon" src="@/assets/images/main/file-upload.svg" />
                                                    Upload
                                                </file-upload>

                                                <span class="text-danger text-sm" style="margin-top: 0;"
                                                    v-show="errors.has('lcaDocument')">{{
                                                        errors.first("lcaDocument") }}</span>

                                                <ul class="uploaded-list">
                                                    <vs-chip @click="remove(document, index)"
                                                        v-for="(item, index) in document" :key="index" closable
                                                        v-if="item.status"> {{ item.name }} </vs-chip>
                                                </ul>
                                            </div>
                                        </div>
                                    </vx-input-group>
                                    <div>

                                    </div>
                                </div>
                            </div>
                            <div class="text-danger text-sm formerrors" v-show="formerrors.msg"
                                @click="formerrors.msg = ''">
                                <vs-alert color="warning"
                                    class="warning-alert reg-warning-alert no-border-radius mb-0 mt-3"
                                    icon-pack="IntakePortal" icon="IP-information-button" active="true">{{
                                        formerrors.msg
                                    }}</vs-alert>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="popup-footer relative">
                    <figure v-if="loading" class="loader">
                        <img src="@/assets/images/main/loader.gif" />
                    </figure>
                    <button color="dark" @click="closeAddDocPopup(); formerrors.msg = ''" class="cancel"
                        type="filled">Cancel</button>
                    <button color="success" :disabled="uploadFinalMainDocuments.length <= 0"
                        @click="updateDocumentsList()" class="save" type="filled">Submit</button>

                </div>
            </div>
        </modal>
        <modal name="manageTagsModal" classes="v-modal-sec linklca" :min-width="200" :min-height="200"
            :scrollable="true" :reset="true" width="1300px" height="auto">
            <div class="v-modal">
                <div class="popup-header fromDetailsPage">
                    <h2 class="popup-title"> Tags </h2>
                    <span @click="closeManageTagsModal()"> <em class="material-icons">close</em> </span>
                </div>
            </div>
            <form data-vv-scope="manageTagsForm" @submit.prevent @keydown.enter.prevent>
                <div class="linklca_form new_label_form" @click="formErrors = ''">
                    <div class=" linklca_form_header flex-wrap pb-2">
                        <div class="vx-row items-end">
                            <div class="vx-col">
                                <div class="form_group">
                                    <label class="form_label">Name of the Tag</label>
                                    <immiInput name="tagName" v-validate="''" class="" data-vv-as="Name of the Tag"
                                        v-model="newTag" />
                                </div>
                            </div>
                            <div class="vx-col">
                                <vs-button :disabled="!newTag || addingTag" class="primary-btn"
                                    @click="addTag(newTag, 'manageTagsForm')">Create</vs-button>
                            </div>
                        </div>
                    </div>
                    <div class="form-container pad0">
                        <div class="accordian-table custom-table no-wrap relative">
                            <NoDataFound ref="NoDataFoundRef" :loading="isTagsListLoading" v-if="tagsList.length == 0"
                                content="" :heading="'No Results Found'" type='petitions' />
                            <div v-if="tagsList.length > 0">
                                <vs-table :data="tagsList">
                                    <template v-if="tagsList.length > 0" slot="thead">
                                        <vs-th>
                                            <a @click="sortMe('tag')"
                                                v-bind:class="{ 'sort_ascending': sortKeys['tag'] == 1, 'sort_descending': sortKeys['tag'] != 1 }">Name</a>
                                        </vs-th>
                                        <vs-th>
                                            <a @click="sortMe('createdByName')"
                                                v-bind:class="{ 'sort_ascending': sortKeys['createdByName'] == 1, 'sort_descending': sortKeys['createdByName'] != 1 }">Created
                                                By</a>
                                        </vs-th>
                                        <vs-th>
                                            <a @click="sortMe('createdOn')"
                                                v-bind:class="{ 'sort_ascending': sortKeys['createdOn'] == 1, 'sort_descending': sortKeys['createdOn'] != 1 }">Created
                                                On</a>
                                        </vs-th>
                                        <vs-th>
                                            <a @click="sortMe('updatedOn')"
                                                v-bind:class="{ 'sort_ascending': sortKeys['updatedOn'] == 1, 'sort_descending': sortKeys['updatedOn'] != 1 }">Updated
                                                On</a>
                                        </vs-th>
                                        <vs-th class="actions">Actions</vs-th>
                                    </template>
                                    <template slot-scope="{ data }">
                                        <vs-tr :data="tagItem" :key="'tagItem' + ind" v-for="(tagItem, ind) in tagsList"
                                            class="vs-table--tr">
                                            <vs-td> <span>{{ checkProperty(tagItem, 'tag') }}</span> </vs-td>
                                            <vs-td class="td_label">
                                                <div>{{ checkProperty(tagItem, 'createdByName') }} <br />
                                                    <small> {{ checkProperty(tagItem, 'createdByRoleName') }} </small>
                                                </div>
                                            </vs-td>
                                            <vs-td> <span> {{ checkProperty(tagItem, 'createdOn') | formatDate }}
                                                </span>
                                            </vs-td>
                                            <vs-td> <span> {{ checkProperty(tagItem, 'updatedOn') | formatDate | empty
                                            }}</span> </vs-td>
                                            <vs-td>
                                                <div class="action-icons">
                                                    <a class="edit IB_tooltip"
                                                        @click="editTag = true; selectedTagForEdit = tagItem; newTag = tagItem.tag">
                                                        <div class="tooltip_cnt">
                                                            <p>
                                                                Edit
                                                            </p>
                                                        </div>
                                                    </a>
                                                </div>
                                            </vs-td>
                                        </vs-tr>
                                    </template>
                                </vs-table>
                                <div class="table_footer">


                                    <!-- <div class="vx-col  con-select pages_select" v-if="labelsList.length > 0">
                                    <label class="typo__label">Per Page</label>
                                    <multiselect @input="changeperPage()" v-model="perpage" :options="perPeges" :multiple="false"
                                    :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Per Page"
                                    :preselect-first="true">

                                    </multiselect>
                                </div> -->

                                    <!-- <paginate v-if="labelsList.length > 0" v-model="page" :page-count="totalpages" :page-range="3"
                                    :margin-pages="2" :click-handler="pageNate"
                                    prev-class="vs-pagination--buttons btn-prev-pagination vs-pagination--button-prev"
                                    next-class="vs-pagination--buttons btn-next-pagination vs-pagination--button-next" :prev-text="'<i></i>'"
                                    :next-text="'<i></i>'" :container-class="'pagination vs-pagination--nav'" :page-class="'page-item'">
                                </paginate> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </modal>
        <vs-popup class="holamundo main-popup" :title="confirmAction === 'remove' ? 'Remove Document' : 'Delete Document'" :active.sync="approveConformpopUp">
            <div class="form-container">

                <div class="vx-row">
                    <div class="vx-col w-full">
                        <p> {{ confirmAction === 'remove'
                            ? 'Do you want to remove this document from the case?'
                            : 'Do you want to delete this document?' }}</p>

                    </div>

                </div>

            </div>
            <div class="text-danger text-sm formerrors" v-show="formerrors.msg" @click="formerrors.msg = ''">
                <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius"
                    icon-pack="IntakePortal" icon="IP-information-button" active="true">{{ formerrors.msg }}</vs-alert>
            </div>
            <div class="popup-footer relative">
                 <figure v-if="loading" class="loader">
                    <img src="@/assets/images/main/loader.gif" />
                </figure>
                <vs-button color="dark" class="cancel" type="filled"
                    @click="approveConformpopUp = false">Cancel</vs-button>
                <vs-button color="success" class="save" type="filled" @click="confirmPopupAction()">{{ confirmAction === 'remove' ? 'Remove' : 'Delete' }}</vs-button>
            </div>
        </vs-popup>
        <vs-popup class="holamundo main-popup" :title="editTag ? 'Edit Tag' : 'Add Tag'" :active.sync="showTagPopup"
            @close="closeAddTagPopup">
            <div class="form-container">
                <div class="vx-row">
                    <div class="vx-col w-full">
                        <immiInput wrapclass="md:w-full" :formscope="''" v-model="newTag" :display="true"
                            :fieldName="'newTag'" :cid="'newTag'" :required="true" label="Tag" placeHolder="Tag" />
                    </div>
                </div>
            </div>
            <div class="popup-footer">
                <vs-button color="dark" class="cancel" type="filled" @click="closeAddTagPopup">Cancel</vs-button>
                <vs-button color="success" class="save" type="filled" :disabled="!newTag || addingTag"
                    @click="addTag(newTag)">{{ editTag ? 'Update' : 'Add' }}</vs-button>
            </div>
        </vs-popup>
        <vs-popup class="holamundo main-popup" :title="addTagToDocument ? 'Add Tag to Document' : 'Link Case'" :active.sync="showLinkCaseOrTagPopup"
            @close="closeLinkCaseOrTagPopup">
            <div class="form-container">
                <div class="vx-row">
                    <div class="vx-col w-full">
                        <div class="form_group city-form">
                            <div class="vx-col w-full">
                                <div v-if="!addTagToDocument" class="form_group city-form">
                                    <div class="con-select con-select-mb20 select-large addselect">
                                        <label class="form_label">Select Cases</label>
                                        <multiselect :name="'cases'" v-model="selectedCasesForLink" :show-labels="false"
                                            track-by="_id" label="name" data-vv-as="Cases" placeholder="Select Cases"
                                            :options="linkCaseOptions"
                                            :custom-label="(item) => checkProperty(item, 'name') + ' (' + checkProperty(item, 'employeeName') + ')'"
                                            :searchable="true" :allow-empty="true" :multiple="true"
                                            :close-on-select="false" :hide-selected="true">
                                            <span slot="noResult">No Cases Found</span>
                                            <template slot="selection" slot-scope="{ values, isOpen }">
                                                <span class="multiselect__selectcustom"
                                                    v-if="values.length && !isOpen">{{
                                                        values.length }} Case(s) Selected</span>
                                                <span class="multiselect__selectcustom"
                                                    v-if="values.length && isOpen"></span>
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>
                                <div v-if="addTagToDocument" class="form_group city-form">
                                    <div class="con-select con-select-mb20 select-large addselect">
                                        <label class="form_label">Select Tag(s)</label>
                                        <multiselect :name="'tags'" v-model="selectedTagsForLink" :show-labels="false"
                                            track-by="tag" label="tag" data-vv-as="Tag(s)" tag-placeholder="Add"
                                            :taggable="true" @tag="addTag" placeholder="Select Tag(s)"
                                            :options="linkTagOptions" :searchable="true" :allow-empty="true" :multiple="true"
                                            :close-on-select="false" :hide-selected="true" :disabled="addingTag">
                                            <span slot="noResult">No Tags Found</span>
                                            <template slot="selection" slot-scope="{ values, isOpen }">
                                                <span class="multiselect__selectcustom"
                                                    v-if="values.length && !isOpen">{{
                                                        values.length }} Tag(s) Selected</span>
                                                <span class="multiselect__selectcustom"
                                                    v-if="values.length && isOpen"></span>
                                            </template>
                                        </multiselect>
                                    </div>
                                    <span class="add-tag" @click="showAddTagPopup = true">Add new tag</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="popup-footer relative">
                <figure v-if="loading" class="loader">
                    <img src="@/assets/images/main/loader.gif" />
                </figure>
                <vs-button color="dark" class="cancel" type="filled" @click="closeLinkCaseOrTagPopup">Cancel</vs-button>
                <vs-button color="success" class="save" type="filled"
                    :disabled="loading || (!addTagToDocument && checkProperty(selectedCasesForLink, 'length') <= 0) || (addTagToDocument && checkProperty(selectedTagsForLink, 'length') <= 0)"
                    @click="linkCaseOrTagToDocument">Submit</vs-button>
            </div>
        </vs-popup>
        <vs-popup class="document_modal document_modal-v2" :class="{ expand: expandModal }"
            :title="checkProperty(selectedFile, 'name')" :active.sync="docPrivew">
            <div class="document_actions" @click="expandModal = !expandModal">
                <figure v-if="!expandModal" class="maximize-img"><img src="@/assets/images/maximize.png" width="18"
                        height="18" /></figure>
                <figure v-else class="minimize-img"><img src="@/assets/images/minimize.png" width="20" height="20" />
                </figure>
            </div>
            <h2>
                <img :class="{
                    'pdf_view_download': docType == 'pdf',
                    'office_view_download': docType == 'office',
                    'image_view_download': docType == 'image'
                }" class="download-button" @click="downloads3file(selectedFile)" src="@/assets/images/download.svg" />
            </h2>
            <div>
                <span
                    :class="{ 'pdf_view_close': docType == 'pdf', 'office_view_close': docType == 'office', 'image_view_close': docType == 'image' }"
                    class="close close2" @click="docPrivew = false"></span>
                <template v-if="docType == 'office'">


                    <div style="height:90vh">

                        <div id="officeDocView" style="height:100%"></div>
                    </div>

                </template>
                <template v-else-if="docType == 'image'">
                    <img :src="docValue">
                </template>
                <template v-else-if="docType == 'pdf'">
                    <div class="pdf" style="height: 90vh">
                        <!-- <object :data="docValue" type="application/pdf" width="1000" height="600" v-if="docPrivew">
                            alt : <a :href="docValue">PDF</a>
                        </object> -->

                        <iframe v-if="docValue != '' && docPrivew" border="0" style="border: 0px" :src="docValue"
                            height="100%" width="100%">PDF</iframe>
                    </div>
                </template>
            </div>
        </vs-popup>

        <vs-popup class="holamundo main-popup" title="Attach from Company Library"
            :active.sync="showAttachFromLibraryPopup">
            <div class="form-container">

                <div class="form_group">
                    <label class="form_label">Select Documents</label>
                    <multiselect v-model="selectedLibraryDocuments" :options="libraryDocuments" track-by="_id"
                        label="name" placeholder="Select Documents" :multiple="true" :close-on-select="false"
                        :custom-label="doc => `${doc.name} (v${doc.version || '-'})`"  :hide-selected="true">
                        <template slot="selection" slot-scope="{ values, isOpen }">
                            <span class="multiselect__selectcustom"
                                v-if="values.length && !isOpen">{{
                                    values.length }} Document(s) Selected</span>
                            <span class="multiselect__selectcustom"
                                v-if="values.length && isOpen"></span>
                        </template>
                    </multiselect>
                </div>

                <div class="form_group mt-3 mb-3">
                    <label class="form_label">Add Tag(s)</label>
                    <multiselect v-model="selectedLibraryTags" :options="availableLibraryTags" track-by="tag" label="tag"
                        placeholder="Select or add tags" :multiple="true" :close-on-select="false" :taggable="true"
                        @tag="addTag" :disabled="!selectedLibraryDocuments.length" :hide-selected="true" >
                        <template slot="selection" slot-scope="{ values, isOpen }">
                            <span class="multiselect__selectcustom"
                                v-if="values.length && !isOpen">{{
                                    values.length }} Tag(s) Selected</span>
                            <span class="multiselect__selectcustom"
                                v-if="values.length && isOpen"></span>
                        </template>
                    </multiselect>
                    <span v-if="selectedLibraryDocuments.length" class="add-tag mt-2" @click="showAddTagPopup = true">Add new tag</span>
                </div>

            </div>

            <div class="popup-footer relative mt-3">
                <figure v-if="loading" class="loader">
                    <img src="@/assets/images/main/loader.gif" />
                </figure>

                <vs-button color="dark" class="cancel" type="filled" :disabled="loading"
                    @click="closeAttachFromLibrary">
                    Cancel
                </vs-button>

                <vs-button color="success" class="save" type="filled"
                    :disabled="loading || selectedLibraryDocuments.length === 0" @click="attachDocumentsFromLibrary">
                    Attach
                </vs-button>
            </div>
        </vs-popup>

    </div>
</template>
<script>
import fileUploadNote from "@/views/common/fileUploadNote.vue";
//import FileUpload from "vue-upload-component/src";
import moment from "moment";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Paginate from "vuejs-paginate";
import NoDataFound from "@/views/common/noData.vue";
import FileUpload from "@/views/FileUploadNew.vue";
import selectField from "@/views/forms/fields/simpleselect.vue";
import immiInput from "@/views/forms/fields/simpleinput.vue";
import { MoreVerticalIcon } from 'vue-feather-icons';
import vsInvDropdown from "@/views/vs-inv-dropdown.vue"
import DateRangePicker from "vue2-daterange-picker";

export default {
    components: {
        NoDataFound,
        fileUploadNote,
        Paginate,
        FileUpload,
        VuePerfectScrollbar,
        selectField,
        immiInput,
        MoreVerticalIcon,
        vsInvDropdown,
        DateRangePicker
    },
    provide() {
        return {
            parentValidator: this.$validator
        }
    },
    props: {
        fromDetailsPage: {
            type: Boolean,
            default: false
        },
        i9Id: {
            type: String,
            default: ''
        }
    },
    data: () => ({
        finalSelectedDateRange: [],
        autoApply: '',
        finalSelectedTagsForFilter: [],
        selectedDateRange: ["", ""],
        selectedTagsForFilter: [],
        showAttachFromLibraryPopup: false,
        libraryDocuments: [],
        selectedLibraryDocuments: [],
        selectedLibraryTags: [],
        confirmAction: '',
        addTagToDocument: false,
        linkTagOptions: [],
        linkCaseOptions: [],
        loading: false,
        selectedTagsForLink: [],
        selectedCasesForLink: [],
        showLinkCaseOrTagPopup: false,
        replaceDocument: false,
        sortKey: {},
        sortKeys: {},
        editTag: false,
        selectedTagForEdit: null,
        totalpages: 0,
        page: 1,
        totalCount: 0,
        perPeges: [10, 25, 50, 75, 100],
        perpage: 25,
        settings: '',
        isTagsListLoading: false,
        addingTag: false,
        newTag: '',
        newDocument: {
            tags: [],
            cases: []
        },
        i9List: [],
        showAddTagPopup: false,
        tagsList: [],
        document: [],
        documentId: "",
        formerrors: {
            msg: ""
        },
        formLetterType: 'Form',
        uploadFinalMainDocuments: [],
        employerId: null,
        documentsList: [],
        selectedItem: null,
        approveConformpopUp: false,
        selectedFile: null,
        docValue: "",
        docPrivew: false,
        docType: false,
        expandModal: false,
        isListLoading: false

    }),
    computed: {
        showTagPopup() {
            return this.showAddTagPopup || this.editTag
        },
        availableLibraryTags() {
            if (!this.selectedLibraryDocuments.length) {
                return []
            }

            const usedTags = new Set()

            this.selectedLibraryDocuments.forEach(doc => {
                const docTags = this.checkProperty(doc, 'tags') || []
                docTags.forEach(t => {
                    if (t.tag) {
                        usedTags.add(t.tag)
                    }
                })
            })

            return this.tagsList.filter(tagObj => !usedTags.has(tagObj.tag))
        }
    },
    watch: {
        i9Id(val){
            if(val){
                this.getDocumentsList()
            }
        },
        selectedLibraryDocuments() {
            this.selectedLibraryTags = []
        }
    },
    mounted() {
        if (this.checkProperty(this.$store.state, 'user') && this.checkProperty(this.$store.state, 'user', '_id')) {
            this.employerId = this.checkProperty(this.$store.state, 'user', '_id')
        }
        this.getDocumentsList();
        this.getI9List();
        this.getTagsList();
    },
    methods: {
        changeperPage(){
          this.page = 1;
          this.getDocumentsList()
        },    
        clear_filter(){
            document.body.classList.remove('scroll-hidden')
            this.finalSelectedTagsForFilter = [];
            this.selectedTagsForFilter = [];
            this.selectedDateRange = ["", ""];
            this.finalSelectedDateRange = [];
            this.getDocumentsList()
        },
        set_filter(){
            document.body.classList.remove('scroll-hidden')
            if(this.checkProperty(this.selectedTagsForFilter, 'length') > 0){
                this.finalSelectedTagsForFilter = this.selectedTagsForFilter.map(tag=>({tag: this.checkProperty(tag, 'tag')}))
            }

            if (
                this.selectedDateRange["startDate"] &&
                this.selectedDateRange["startDate"] != "" &&
                this.selectedDateRange["endDate"] != "" &&
                this.selectedDateRange["endDate"]
            ) {
                this.finalSelectedDateRange = [this.selectedDateRange["startDate"],this.selectedDateRange["endDate"]];
            }
            this.getDocumentsList()
        },
        closeAttachFromLibrary() {
            this.showAttachFromLibraryPopup = false
            this.selectedLibraryDocuments = []
            this.selectedLibraryTags = []
        },
        attachDocumentsFromLibrary() {
            this.loading = true

            let payload = {
                documentIds: this.selectedLibraryDocuments.map(d => this.checkProperty(d, '_id')),
                i9Id: this.i9Id,
                tags: this.selectedLibraryTags.map(tag => ({ tag: this.checkProperty(tag, 'tag') }))
            }

            let path = '/i9/attach-documents'

            this.$store.dispatch('commonAction', { data: payload, path })
                .then(response => {
                this.showToster({
                    message: this.checkProperty(response, 'message'),
                    isError: false
                })
                this.getDocumentsList()
                this.closeAttachFromLibrary()
                })
                .catch(error => {
                    this.showToster({ message: error, isError: true })
                })
                .finally(() => {
                    this.loading = false
                })
        },
        openAttachFromLibrary() {
            this.showAttachFromLibraryPopup = true
            this.selectedLibraryDocuments = []
            this.selectedLibraryTags = []
            this.fetchCompanyLibraryDocuments()
        },
        fetchCompanyLibraryDocuments() {

            let payload = {
                companyId: this.checkProperty(this.getUserData, 'companyId'),
                page: 1,
                perpage: 100000
            }

            this.$store.dispatch("getList", {
                data: payload,
                path: "/company/documents-list"
            })
            .then(response => {
                const allDocs = response.list || []

                this.libraryDocuments = allDocs.filter(doc => {
                const isActive = this.checkProperty(doc, 'status') === true
                const linkedI9s = this.checkProperty(doc, 'linkedI9') || []

                const isAlreadyLinked = linkedI9s.some(
                    i9 => this.checkProperty(i9, '_id') === this.i9Id
                )

                return isActive && !isAlreadyLinked
                })
            })
        },
        confirmPopupAction() {
            if (this.confirmAction === 'remove') {
                this.removeCaseLink()
            } else {
                this.deleteDocument()
            }
        },
        removeCaseLink() {
            this.loading = true
            let payload = {
                documentId: this.checkProperty(this.selectedItem, '_id'),
                i9Id: this.i9Id,
                unlinkI9: true
            }

            this.$store.dispatch('replaceCompanyDocuments', payload)
                .then(response => {
                    this.showToster({ message: this.checkProperty(response, 'message'), isError: false })
                    this.approveConformpopUp = false
                    this.selectedItem = null
                    this.getDocumentsList()
                })
                .catch(error => {
                    this.formerrors.msg = error
                }).finally(() => {
                    this.loading = false
                })
        },
         openRemoveConfirmPopup(item) {
            this.selectedItem = item
            this.approveConformpopUp = true
            this.confirmAction = 'remove'
            this.formerrors.msg = ''
        },
        closeLinkCaseOrTagPopup() {
            this.showLinkCaseOrTagPopup = false
            this.selectedItem = null
            this.selectedCasesForLink = []
            this.selectedTagsForLink = []
            this.addTagToDocument = false
            this.newDocument.tags = []
            this.$validator.reset()
        },
        linkCaseOrTagToDocument(document = null, type = 'case') {
            if (!this.showLinkCaseOrTagPopup) {
                this.selectedItem = document
                if (type == 'case') {
                    let i9Ids = this.checkProperty(document, 'linkedI9').map(el => this.checkProperty(el, '_id'))
                    this.linkCaseOptions = this.i9List.filter(item => !i9Ids.includes(item._id))
                    this.addTagToDocument = false
                } else {
                    this.addTagToDocument = true
                    let tags = this.checkProperty(document, 'tags').map(el => this.checkProperty(el, 'tag'))
                    this.linkTagOptions = this.tagsList.filter(item => !tags.includes(item.tag))
                }
                this.showLinkCaseOrTagPopup = true
                return;
            }
            let payload = {
                documentId: this.checkProperty(this.selectedItem, '_id'),
                fromRowActions: true
            }
            if(this.addTagToDocument){
                payload['tags'] = this.selectedTagsForLink.map((item) => ({ tag: item.tag }))
            }else{
                payload['I9ids'] = this.selectedCasesForLink.map(caseItem => this.checkProperty(caseItem, '_id'))
            }
            let path = '/company/document-replace'
            this.loading = true
            this.$store.dispatch('commonAction', { data: payload, path }).then(response => {
                this.showToster({ message: this.checkProperty(response, 'message'), isError: false })
                this.getDocumentsList()
                this.closeLinkCaseOrTagPopup()
            }).catch(error => {
                this.showToster({ message: error, isError: true })
            }).finally(() => {
                this.loading = false
            })
        },
        restoreDocument(document) {
            let payload = {
                documentId: this.checkProperty(document, '_id')
            }
            let path = '/company/documents-restore'
            this.$vs.loading()
            this.$store.dispatch('commonAction', { data: payload, path }).then(response => {
                this.showToster({ message: this.checkProperty(response, 'message'), isError: false })
                this.getDocumentsList()
            }).catch(error => {
                this.showToster({ message: error, isError: true })
            }).finally(() => {
                this.$vs.loading.close()
            })
        },
        showPopupForReplace(document) {
            this.selectedItem = document
            let tags = document.tags.map(el => el.tag)
            let cases = document.linkedI9.map(el => el._id)
            this.newDocument['tags'] = this.tagsList.filter(tagItem => tags.includes(tagItem.tag))
            this.newDocument['cases'] = this.i9List.filter(i9 => cases.includes(i9._id))
            this.replaceDocument = true
            this.$modal.show('addDocumentPopup')
        },
        sortMe(sort_key = '') {
            if (sort_key != '') {
                this.sortKeys[sort_key] = this.sortKeys[sort_key] == 1 ? -1 : 1
                this.sortKey = {};
                this.sortKey = { "path": sort_key, "order": this.sortKeys[sort_key] };
                this.getTagsList()
            }
        },
        pageNate(pageNum) {
            this.page = pageNum;
            this.getDocumentsList();
        },
        scrollHandle(ev) { },
        closeManageTagsModal() {
            this.$modal.hide('manageTagsModal');
            this.newTag = '';
        },
        getTagsList() {
            let payload = {
                companyId: this.checkProperty(this.getUserData, 'companyId'),
                sorting: this.sortKey
            }
            this.isTagsListLoading = true;
            this.$store.dispatch("commonAction", { data: payload, path: '/company/doc-tag-list' }).then((response) => {
                this.tagsList = response;
            }).catch(error => {
                console.log(error);
            }).finally(() => {
                this.isTagsListLoading = false;
            })
        },
        closeAddTagPopup() {
            this.showAddTagPopup = false;
            this.editTag = false;
            this.selectedTagForEdit = null;
            this.newTag = '';
            this.$validator.reset();
        },
        openi9() {
            this.closeAddDocPopup();
            setTimeout(() => {
                this.$router.push({ name: 'Form I-9', params: { openCreatePopup: true } }).catch(err => { })
            }, 100);
        },
        getI9List() {
            let payload = {
                page: 1,
                perpage: 100,
                sorting: {},
                matcher: {
                    status: true
                }
            }
            this.$store.dispatch("commonAction", { data: payload, path: 'i9/list' }).then((response) => {
                let tempList = this.checkProperty(response, 'list').map((item) => {
                    return {
                        _id: item._id,
                        name: item.customId,
                        employeeName: this.checkProperty(item, 'beneficiaryInfo', 'name')
                    }
                });
                this.i9List = [...tempList];
            });
        },
        addTag(tag, scope) {
            let payload = {}
            let path = ''
            if (this.editTag) {
                payload['tagId'] = this.checkProperty(this.selectedTagForEdit, '_id')
                payload['updatedTag'] = tag
                path = '/company/doc-tag-update'
            } else {
                payload['companyId'] = this.checkProperty(this.getUserData, 'companyId')
                payload['newTag'] = tag
                path = '/company/doc-tag-create'
            }
            this.addingTag = true;
            this.$store.dispatch("commonAction", { data: payload, path: path }).then((response) => {
                this.getTagsList();
                this.getDocumentsList()
                if (scope !== 'manageTagsForm' && !this.editTag) {
                    if(showAttachFromLibraryPopup){
                        this.selectedLibraryTags.push(newTag)
                    }else{
                        let newTag = { tag: this.checkProperty(response, 'tag') };
                        this.newDocument.tags.push(newTag);
                        this.selectedTagsForLink.push(newTag)
                    }
                }
                this.closeAddTagPopup()
                this.showToster({ message: this.checkProperty(response, 'message'), isError: false });
            }).catch(error => {
                this.showToster({ message: error, isError: true });
            }).finally(() => {
                this.newTag = '';
                this.addingTag = false;
            })
        },
        closeAddDocPopup() {
            this.document = [];
            // this.categorytErr = [];
            // this.categorytErrMesg = [];
            this.newDocument.tags = [];
            this.newDocument.cases = [];
            this.replaceDocument = false;
            this.selectedTagsForLink = [];
            this.$modal.hide("addDocumentPopup");
        },
        openAddDocPopup() {
            // this.categorytErr = [];
            // this.categorytErrMesg = [];
            this.$modal.show("addDocumentPopup");
        },
        updateData(docs, category) {
            if (category == 'document') {
                this.uploadFinalMainDocuments = docs;

            }
        },
        remove(item, index) {
            item.splice(index, 1);
        },
        openConformPopUp(item) {
            this.selectedItem = item;
            this.approveConformpopUp = true;
            Object.assign(this.formerrors, { msg: '' });
        },
        updateDocumentsList() {
            let action = 'uploadCompanyDocuments'
            Object.assign(this.formerrors, { msg: '' })
            if (this.disable_uploadBtn) {
                return false;
            }
            // let employerId = null;
            // if(this.checkProperty(this.$store.state,'user') && this.checkProperty(this.$store.state,'user','_id')){
            //  employerId = this.checkProperty(this.$store.state,'user','_id')
            // }
            let postData = {
                companyId: this.checkProperty(this.getUserData, 'companyId'),
                formLetterType: this.formLetterType,
                documents: [],
                I9ids: this.checkProperty(this.newDocument, 'cases').map((item) => item._id),
                tags: this.checkProperty(this.newDocument, 'tags').map((item) => ({ tag: item.tag })),
            };
            if (this.replaceDocument) {
                action = 'replaceCompanyDocuments'
                postData['documentId'] = this.checkProperty(this.selectedItem, '_id')
            }
            if (this.documentId) {
                postData = Object.assign(postData, { "parentId": this.documentId })
            }
            if (this.uploadFinalMainDocuments.length > 0) {

                this.uploadFinalMainDocuments.forEach((doc) => {
                    let docu = doc
                    // let document = doc.document
                    // document = Object.assign(document ,{ name:doc.name})
                    postData['documents'].push(docu);
                })
                this.loading = true
                this.$store
                    .dispatch(action, postData)
                    .then(response => {

                        this.showToster({ message: response.message, isError: false })
                        this.getDocumentsList();
                        this.closeAddDocPopup()


                    })
                    .catch((error) => {
                        Object.assign(this.formerrors, { 'msg': error })
                        //this.showToster({ message: error, isError: true });
                    }).finally(()=>{
                        this.loading = false
                    })

            } else {
                Object.assign(this.formerrors, { msg: 'Upload atleast one document' })

            }

        },
        getDocumentsList() {
            this.documentsList = [];
            this.updateLoading(true);
            this.isListLoading = true;
            let postData = { companyId: this.checkProperty(this.getUserData, 'companyId'), 'page': this.page, 'perpage': this.perpage };
            postData['matcher'] = {
                tags: this.finalSelectedTagsForFilter,
                createdDateRange: this.finalSelectedDateRange
            }
            if(this.fromDetailsPage && this.i9Id){
                postData['matcher']['linkedI9s'] = [this.i9Id]
            }
            this.$store.dispatch("getList", { data: postData, path: "/company/documents-list" })
                .then(response => {
                    this.documentsList = response.list;
                    console.log('documentsList', this.documentsList)
                    setTimeout(() => {
                        this.isListLoading = false;
                        this.updateLoading(false);
                    })
                    this.totalCount = response.totalCount
                    this.totalpages = Math.ceil(response.totalCount / this.perpage);


                }).catch((err) => {
                    this.documentsList = [];
                    setTimeout(() => {
                        this.isListLoading = false;
                        this.updateLoading(false);
                    })

                })




        },
        deleteDocument() {

            let postdata = {
                documentId: this.selectedItem._id
            };
            this.$store.dispatch("deleteCompanyDoc", postdata).then(response => {

                this.showToster({ message: response.message, isError: false });
                this.selectedItem = null;
                this.approveConformpopUp = false;
                this.getDocumentsList();


            })
                .catch((error) => {
                    Object.assign(this.formerrors, { 'msg': error })
                    //this.showToster({ message: error, isError: true });
                    this.approveConformpopUp = true;
                });
        },
        getformated(item) {
            //YYYY-MM-DD  HH:mm:ss
            if (item.createdOn) {
                return (
                    "Uploaded On  " +
                    moment(item.createdOn).format("MMM DD, YYYY hh:mm:ss a") +
                    " - Uploaded by " + item.createdByName
                    // +" "+item.parentId +" id="+item._id
                );

            } else if (item.uploadedOn) {
                return (
                    "Uploaded On  " +
                    moment(item.uploadedOn).format("MMM DD, YYYY hh:mm:ss a") +
                    " - Uploaded by " + item.createdByName
                    // +" "+item.parentId +" id="+item._id
                );

            } else {
                return 'Uploaded by ' + item.createdByName
            }

        },
        fetchSignedUrl(value, download = false, viewmode = false) {
            value.download = download;
            value.viewmode = viewmode;

            this.download_or_view(value);
            // window.open(this.$globalgonfig._APIURL+"/common/viewfile?path="+value.path, "_blank");


        },
        download_or_view(docItem) {

            let value = _.cloneDeep(docItem);
            this.expandModal = false;
            if (this.checkProperty(value, 'name')) {
                let docName = _.cloneDeep(value['name']);
                value['name'] = docName;
            }


            var _self = this;
            this.formSubmited = false;
            if (_.has(value, "path")) {
                value["url"] = value["path"];
                value["document"] = value["path"];
            }

            if (_.has(value, "url")) {
                value["path"] = value["url"];
                value["document"] = value["url"];
            }

            if (_.has(value, "document")) {
                value["path"] = value["document"];
                value["url"] = value["document"];
            }
            // value = Object.assign(value ,{ 'petitionId':this.petition['_id']})
            // value = Object.assign(value ,{ 'subTypeDetails':this.petition['subTypeDetails']})


            this.selectedFile = value;
            this.docValue = "";
            this.docPrivew = false;
            this.docType = false;
            this.docType = this.findmsDoctype(value);

            if ((this.docType == "office" || this.docType == "image" || this.docType == "pdf")) {
                //if ( (this.docType == "office" || this.docType == "image" || this.docType == "pdf") && value.download == false ) {
                value.url = value.url.replace(this.$globalgonfig._S3URL, "");
                value.url = value.url.replace(this.$globalgonfig._S3URLAWS, "");
                let postdata = {
                    keyName: value.url,
                    // "petitionId":value['petitionId'],

                    // entityType:value['petitionId']
                    // "fileName":value.name?value.name:''
                };

                this.$store.dispatch("getSignedUrl", postdata).then((response) => {
                    this.docValue = response.data.result.data;

                    if (this.docType == "office") {
                        document.getElementById("officeDocView").innerHTML = "  <div  id='officeDocViewTemplate' style='height:100%'></div>";
                        let _editing = true;

                        if ([48, 50, 51].indexOf(this.getUserRoleId) > -1) {
                            _editing = false;
                        }

                        if (value.viewmode) {
                            _editing = false;
                        }
                        var _ob = {}
                        if (value.editedDocument) {
                            _ob = {

                                // petitionId:_self.checkProperty(_self.petition ,'_id'),
                                name: value.name,
                                _id: value._id,
                                "extn": "docx",
                                "formLetterType": "Letter",
                                parentId: value.parentId
                            }

                        } else {

                            _ob = {

                                name: value.name,
                                // petitionId:_self.checkProperty(_self.petition ,'_id'),
                                _id: value._id,
                                "extn": "docx",
                                "formLetterType": "Letter",
                                parentId: value._id

                            }

                        }


                        window.docEditor = new DocsAPI.DocEditor("officeDocViewTemplate",
                            {

                                "document": {
                                    "c": "forcesave",
                                    "fileType": "docx",
                                    "key": value._id,
                                    "userdata": JSON.stringify(_ob),
                                    "title": value.name,
                                    "url": response.data.result.data,
                                    permissions: {
                                        edit: _editing,
                                        download: true,
                                        reader: false,
                                        review: false,
                                        comment: false
                                    }
                                },

                                "documentType": "word",
                                "height": "100%",
                                "width": "100%",

                                "editorConfig": {
                                    "userdata": JSON.stringify(_ob),
                                    "callbackUrl": "https://immibox.com/api/perm/post-edited-document?payload=" + JSON.stringify(_ob) + "&token=" + _self.$store.state.token + "&name=" + value.name.replace('.docx', ''),
                                    "customization": {
                                        "logo": {
                                            "image": "https://immibox.com/app/favicon.png",
                                            "imageDark": "https://immibox.com/app/favicon.png",
                                            "url": "https://immibox.com"
                                        },
                                        "anonymous": {
                                            "request": false,
                                            "label": "Guest"
                                        },
                                        "chat": false,
                                        "comments": false,
                                        "compactHeader": false,
                                        "compactToolbar": true,
                                        "compatibleFeatures": false,
                                        "feedback": {
                                            "visible": false
                                        },
                                        "forcesave": true,
                                        "help": false,
                                        "hideNotes": true,
                                        "hideRightMenu": true,
                                        "hideRulers": true,
                                        layout: {
                                            toolbar: {
                                                "collaboration": false,
                                            },
                                        },
                                        "macros": false,
                                        "macrosMode": "warn",
                                        "mentionShare": false,
                                        "plugins": false,
                                        "spellcheck": false,
                                        "toolbarHideFileName": true,
                                        "toolbarNoTabs": true,
                                        "uiTheme": "theme-light",
                                        "unit": "cm",
                                        "zoom": 100
                                    },
                                }, events: {
                                    onReady: function () {

                                    },
                                    onDocumentStateChange: function (event) {
                                        var url = event.data;
                                        if (!event.data) {

                                            if (value.editedDocument) {

                                            }

                                        }
                                    }

                                }
                            });
                        //this.docValue = encodeURIComponent(response.data.result.data);
                    }

                    if (this.docType == "pdf") {
                        var _vid = value._id;
                        if (value.parentId) {
                            _vid = value.parentId;
                        }
                        var viewmode = 0; //1== edit , 0== Disble Edit
                        let pdfViewUrl = 'https://immibox.com/viewer/pdfjs-dist/web/viewerv2.html';
                        if (_.has(this.$globalgonfig, 'PDF_VIEW_URL')) {
                            pdfViewUrl = this.$globalgonfig['PDF_VIEW_URL']; //PDF_EDIT_URL
                        }
                        if (_.has(value, 'viewmode')) {
                            if (value.viewmode) {
                                viewmode = 0;
                            } else {
                                viewmode = 1;
                                if (_.has(this.$globalgonfig, 'PDF_EDIT_URL')) {
                                    pdfViewUrl = this.$globalgonfig['PDF_EDIT_URL'];
                                }
                            }

                        }

                        this.docValue = pdfViewUrl + "?view=" + viewmode + "+&file=" + encodeURIComponent(response.data.result.data);
                    }
                    this.docPrivew = true;
                });
            } else {



                this.downloads3file(value);
            }

        },
    }
}
</script>